import { useEffect, useMemo } from 'react';
import { useListContext, useUnselectAll } from 'react-admin';
import { useLocation } from 'react-router-dom';

const useClearSelectionsOnChange = (resourceParam) => {
  const { resource: ctxResource, filterValues, displayedFilters, page } = useListContext() ?? {};
  const resource = resourceParam || ctxResource;
  const unselectAll = useUnselectAll(resource);
  const location = useLocation();

  // useMemo to safely stringify objects for stable deps
  const filtersKey = useMemo(() => JSON.stringify(filterValues ?? {}), [filterValues]);
  const displayedFiltersKey = useMemo(() => JSON.stringify(displayedFilters ?? {}), [displayedFilters]);

  useEffect(() => {
    if (!resource) return;

    console.log('[useClearSelectionsOnChange] reset:', {
      resource,
      page,
      filterValues,
      displayedFilters,
      pathname: location.pathname,
    });

    unselectAll();
  }, [resource, page, filtersKey, displayedFiltersKey, location.pathname, unselectAll]);
};

export default useClearSelectionsOnChange;
